import { Box, Link } from "@mui/material";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { AuthTopNav } from "~/components/AuthTopNav";

interface AuthPageLayoutProps {
  loggedIn?: boolean;
  children: ReactNode;
  showFooterLinks?: boolean;
}

export function AuthPageLayout({
  loggedIn = false,
  children,
  showFooterLinks = false,
}: AuthPageLayoutProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f7f8f9",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <AuthTopNav loggedIn={loggedIn} />

      {/* Centered content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 6,
          py: { xs: 3, sm: 6 },
          px: { xs: 2, sm: 3 },
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 480,
            bgcolor: "white",
            borderRadius: "10px",
            border: "1px solid #e9ebee",
            boxShadow: "0 2px 40px rgba(0,0,0,0.1)",
            py: 2,
          }}
        >
          {children}
        </Box>

        {showFooterLinks && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Link
              href={t("auth.termsOfServiceUrl")}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{ fontSize: 14, fontWeight: 500, color: "#374553" }}
            >
              {t("auth.termsOfService")}
            </Link>
            <Box
              sx={{
                width: "1px",
                height: 14,
                bgcolor: "#d0d6db",
              }}
            />
            <Link
              href={t("auth.privacyPolicyUrl")}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{ fontSize: 14, fontWeight: 500, color: "#374553" }}
            >
              {t("auth.privacyPolicy")}
            </Link>
          </Box>
        )}
      </Box>
    </Box>
  );
}
